"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _configureFileManager = _interopRequireDefault(require("FileManagerLib/components/configureFileManager"));

var _FileManagerUtils = require("lead-flows-ui/utils/FileManagerUtils");

var _DragDropContext = _interopRequireDefault(require("lead-flows-ui/utils/DragDropContext"));

var _ImageUploadWithBrowse = _interopRequireDefault(require("FileManagerLib/components/ImageUploadWithBrowse"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var ImageUploadManager =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ImageUploadManager, _PureComponent);

  function ImageUploadManager() {
    (0, _classCallCheck2.default)(this, ImageUploadManager);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageUploadManager).apply(this, arguments));
  }

  (0, _createClass2.default)(ImageUploadManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var _this$props = this.props,
          addValidationError = _this$props.addValidationError,
          imageUrl = _this$props.imageUrl,
          onChange = _this$props.onChange,
          removeValidationError = _this$props.removeValidationError;
      if (!imageUrl) return;
      (0, _FileManagerUtils.handleImageUrl404)(imageUrl, function () {
        addValidationError('imageUrl', _this.langKey('error', 'invalidUrl'));
        onChange(null);
      }, function () {
        removeValidationError('imageUrl');
      });
    } // This is a hack until this issue is fixed in FileManagerLib:
    // https://git.hubteam.com/HubSpot/FileManagerUI/issues/453

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var imageTag = document.querySelector("img[src=\"" + nextProps.imageUrl + "\"]");
      if (!nextProps.imageUrl) return;

      if (imageTag) {
        imageTag.style.width = '100%';
      }
    }
  }, {
    key: "langKey",
    value: function langKey() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return "leadFlowEditor.leadFlowCalloutEditor." + args.join('.');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          auth = _this$props2.auth,
          imageUrl = _this$props2.imageUrl,
          onChange = _this$props2.onChange;
      var FileManager = (0, _configureFileManager.default)({
        httpClient: _apiClient.default
      });
      var ImageUploadContext = (0, _DragDropContext.default)()(_ImageUploadWithBrowse.default);
      return _react.default.createElement(FileManager, {
        auth: auth
      }, _react.default.createElement(ImageUploadContext, {
        imageUrl: imageUrl,
        onChange: onChange
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        addValidationError: _react.default.PropTypes.func.isRequired,
        auth: _react.default.PropTypes.object.isRequired,
        imageUrl: _react.default.PropTypes.string,
        onChange: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        imageUrl: '',
        auth: {}
      };
    }
  }]);
  return ImageUploadManager;
}(_react.PureComponent);

exports.default = ImageUploadManager;
module.exports = exports.default;